import { useState, useEffect } from 'react';
import { Outlet } from "react-router-dom";
import Image from "../components/image/image.component";
import styled from "styled-components";
import bannerImage from "../Assets/banner.png";

const breakpoints = {
    mobile: '480px',
    tablet: '768px',
    desktop: '1024px',
}

const URContainer = styled.div(props => ({
    display: 'flex',
    marginTop: '-40px',
    minHeight: 'calc(100vh - 309px)',

    "@media(max-width: 1023px)": {
        flexDirection: 'column'
    },
    "@media(min-width: 1024px)": {
        justifyContent: 'center'
    },

    '& .logo-banner': {
        "@media(max-width: 1023px)": {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundImage: `url(${bannerImage})`,
            backgroundSize: 'cover', 
            backgroundPosition: 'center', 
        },
        "@media(min-width: 1024px)": {
            width: '40%',
            boxShadow: 'rgba(0, 0, 0, 0.15) 2.4px 2.4px 3.2px',
            marginRight: '5px',
        },
    },

    '& > div': {
        paddingTop: '8vw',
        paddingBottom: '3vw',
      
        '& .logo-container': {
            zIndex: 1,
            width: '100%',
            textAlign: 'center',
            'img': {
                marginTop: '2vw',
            },
            "@media(max-width: 1023px)": {
                width: '80%',
                marginBottom: '-15px',
            }
        },
        
        '&.ur-content-page': {
            width: '70%',
            position: 'relative',
            paddingLeft: '8vw',
            paddingRight: '8vw',
            backgroundColor: '#f9f9f9',
            "@media(max-width: 1023px)": {
                width:'100%',
                paddingTop: '1vw',
                paddingBottom: '0',
                marginBottom: '3rem',
                background: 'transparent'
            },
            "@media(min-width: 1024px)": {
                width: '100%',
            },
        },
        '& nav': {
            marginBottom: '2rem',
            '& a': {
                fontSize: props.theme.fontSizes.h2,
                fontWeight: 600,
                marginBottom: '1rem'
            },
        },
        '& .form-container': {
            '& > *': {
                display: 'block'
            },
            '& button': {
                margin: '1rem 0'
            },
            '& .MuiFormControl-root': {
                width: '100%',
                marginBottom: '1rem',

                '& input': {
                    width: 'calc(100% - 2rem)',
                },
            },
        },
    },
    "@media(max-width: 480px)": {
        flexDirection:'column !important',
        alignItems:'center',
    },
}));

const AuthLayout = () => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 1024);
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <URContainer>
            <div className="logo-banner">
                <div className="logo-container">
                    <Image
                        src={isMobile ? '/logo.png' : '/logo.png'}
                        alt={'Music Bull'}
                        width={'50%'}
                    />
                </div>
            </div>
            <div className="ur-content-page box-sizing">
                <Outlet />
            </div>
        </URContainer>
    )
}

export default AuthLayout;